<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/spotify-profile"></ion-back-button>
    </ion-buttons>
    <ion-title>Lyrics Lookup</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- ─── Not authenticated ─────────────────────────────────────────────── -->
  <div *ngIf="!isAuthenticated" class="auth-prompt">
    <ion-icon name="musical-notes-outline" class="spotify-icon"></ion-icon>
    <p>Connect Spotify first to search for songs.</p>
    <ion-button expand="block" class="spotify-btn" (click)="login()">
      Connect with Spotify
    </ion-button>
  </div>

  <ng-container *ngIf="isAuthenticated">

    <!-- ─── Search bar ─────────────────────────────────────────────────── -->
    <div class="search-wrap">
      <ion-searchbar
        [(ngModel)]="searchQuery"
        (ionInput)="onSearchInput()"
        placeholder="Search for a song…"
        debounce="0"
        animated="true"
        class="search-bar"
      ></ion-searchbar>
    </div>

    <!-- Search spinner -->
    <div *ngIf="searchLoading" class="center-state small">
      <ion-spinner name="dots"></ion-spinner>
    </div>

    <!-- ─── Search results ────────────────────────────────────────────── -->
    <div *ngIf="!searchLoading && searchResults.length > 0" class="results-list">
      <div *ngFor="let track of searchResults" class="result-row">

        <!-- Album art -->
        <img
          *ngIf="albumThumb(track)"
          [src]="albumThumb(track)"
          [alt]="track.album.name"
          class="album-thumb"
        />
        <div *ngIf="!albumThumb(track)" class="album-thumb-placeholder">
          <ion-icon name="musical-note-outline"></ion-icon>
        </div>

        <!-- Track info -->
        <div class="track-info">
          <p class="track-name">{{ track.name }}</p>
          <p class="track-sub">{{ artistNames(track) }} &middot; {{ track.album.name }}</p>
        </div>

        <!-- Lookup Lyrics button -->
        <ion-button
          size="small"
          fill="outline"
          class="lookup-btn"
          [disabled]="loadingTrackId === track.id"
          (click)="lookupLyrics(track)"
        >
          <ion-spinner *ngIf="loadingTrackId === track.id" name="dots" slot="start"></ion-spinner>
          <span *ngIf="loadingTrackId !== track.id">Lyrics</span>
          <span *ngIf="loadingTrackId === track.id">Loading…</span>
        </ion-button>

      </div>
    </div>

    <!-- No results -->
    <div *ngIf="!searchLoading && searchQuery.trim() && searchResults.length === 0" class="center-state small">
      <p class="muted">No results for "{{ searchQuery }}"</p>
    </div>

    <!-- ─── Lyrics section ────────────────────────────────────────────── -->
    <div *ngIf="selectedTrack || lyricsError" class="lyrics-section">
      <div class="lyrics-header" *ngIf="selectedTrack">
        <img
          *ngIf="albumThumb(selectedTrack)"
          [src]="albumThumb(selectedTrack)"
          class="lyrics-thumb"
        />
        <div>
          <p class="lyrics-track-name">{{ selectedTrack.name }}</p>
          <p class="track-sub">{{ artistNames(selectedTrack) }}</p>
        </div>
      </div>

      <!-- Lyrics error -->
      <div *ngIf="lyricsError" class="error-block">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <p>{{ lyricsError }}</p>
      </div>

      <!-- Lyrics lines -->
      <div *ngIf="lines.length > 0">
        <div class="lyrics-meta">
          <span class="meta-pill">{{ syncType }}</span>
          <span class="meta-pill" *ngIf="provider">via {{ provider }}</span>
        </div>
        <div class="lyrics-lines">
          <div *ngFor="let line of lines" class="lyric-line">
            <span class="timestamp">{{ formatTime(line.startTimeMs) }}</span>
            <span class="words">{{ line.words }}</span>
          </div>
        </div>
      </div>

      <!-- No lyrics -->
      <div *ngIf="!lyricsError && rawData && lines.length === 0" class="center-state small">
        <ion-icon name="musical-note-outline"></ion-icon>
        <p class="muted">No lyrics available for this track.</p>
      </div>

      <!-- Raw JSON -->
      <details *ngIf="rawData" class="raw-json">
        <summary>Raw response</summary>
        <pre>{{ rawData | json }}</pre>
      </details>
    </div>

  </ng-container>

</ion-content>
